import { render, staticRenderFns } from "./SmsLogin.vue?vue&type=template&id=bc38e738&scoped=true&"
import script from "./SmsLogin.vue?vue&type=script&lang=js&"
export * from "./SmsLogin.vue?vue&type=script&lang=js&"
import style0 from "./SmsLogin.vue?vue&type=style&index=0&id=bc38e738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc38e738",
  null
  
)

export default component.exports